export default {
  data() {
    return {
      query: null,
      searchError: '',
      timeout: null,
    };
  },
  methods: {
    handleSelect(item) {
      this.formData.entity = item;
    },

    checkResults(results) {
      if (results.length === 0) {
        this.searchError = 'No se encontraron resultados.';
      }
    },

    async querySearchAsync(queryString, cb) {
      this.searchError = '';

      if (!queryString || queryString.length < 1) {
        this.searchError = 'Debe ingresar al menos 1 caracter.';
        return cb([]);
      }

      if (this.query === queryString) {
        return cb(this.selectOptions());
      }

      this.query = queryString;

      await this.fetchData(queryString);

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(this.selectOptions());
      }, 500);
    },
  },
};
